// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"6b3aa6dd","830":"1333cb86"}[chunkId] + ".chunk.js";
};